import React from 'react';

import useMessages from '@/lib/hooks/useMessages';
import useUser from '@/lib/hooks/useUser';

import type { FixSubPage } from '../../types';
import FixMessagesModal from './FixMessagesModal';
import type { MessageProps } from './FixMessagesModal/Message';

const FixMessage: FixSubPage = ({ selectedFix, onClose }) => {
  const { messages, fetchMore, sendMessage } = useMessages(
    'fix',
    selectedFix._id
  );

  const { data: user } = useUser();

  const displayMessages: MessageProps[] = messages.map((message) => ({
    id: message._id,
    content: message.content,
    time: message.createdTime,
    createdAt: message.createdTime,
    name: message.sender.name,
    type: message.sender.id === user?._id ? 'send' : 'receive',
  }));

  return (
    <FixMessagesModal
      title={selectedFix.title}
      messages={displayMessages}
      onClose={onClose}
      fetchMore={fetchMore}
      sendMessage={sendMessage}
    />
  );
};

export default FixMessage;
